<template>
  <div>
    <a-modal modal-id="add-task">
      <div slot="title">Add Task</div>
      <div slot="form">
        <div class="row m-t-xs">
          <label>Project:</label>
          <span v-if="project" class="m-l-lg">
            <strong class="m-l-lg">
              {{ project.name }}
            </strong>
          </span>
          <v-select
            v-else
            :options="projectOptions.length ? projectOptions : projects" index="id" label="name"
            v-model="newTask.project"
            @change="getPbnFromGroup()"
          ></v-select>
        </div>
        <div class="row m-t-xs">
          <label>Title</label>
          <input type="text" class="form-control" v-model="newTask.title">
        </div>
        <div class="row m-t-xs">
          <label>Pbn</label>
          <span v-if="pbn" class="m-l-lg"><strong class="m-l-lg">{{ pbn.domain }}</strong></span>
          <v-select
            v-else-if="loadingPbns || pbnOptions.length"
            :loading="loadingPbns"
            :options="pbnOptions"
            index="id" label="domain"
            placeholder="Select a domain to assign this task to"
            v-model="newTask.linkedResources"
          ></v-select>
        </div>
        <div class="row m-t-xs">
          <label>Description</label>
          <textarea class="form-control" placeholder="Describe your task in a few sentences" cols="30" rows="5" v-model="newTask.description"></textarea>
        </div>
        <div class="row m-t-xs">
          <label>Requested By Client?</label>
          <input type="checkbox" class="abc-checkbox-circle m-l-lg" v-model="newTask.requestedByClient" @change="updatePriority">
        </div>
        <div class="row m-t-xs">
          <label>Priority</label>
          <v-select :options="priorities" index="index" label="label" v-model="newTask.priority"></v-select>
        </div>
        <div class="row m-t-xs">
          <label>Status</label>
          <v-select :options="statuses" label="label" index="index" v-model="newTask.status"></v-select>
        </div>
        <div class="row m-t-xs">
          <label>Due Date</label>
          <input type="date" placeholder="Expected finish date" min="0" class="pretty-input form-control" v-model="newTask.dueDate">
        </div>
        <div class="row m-t-xs">
          <label>Departments</label>
          <v-select multiple :options="departments" label="label" index="index" v-model="newTask.departments"></v-select>
        </div>
        <div class="row m-t-xs">
          <label>Assignee</label>
          <v-select
            :options="users"
            label="username" index="id"
            v-model="newTask.assignee"
          ></v-select>
        </div>
        <div class="row m-t-xs">
          <label>Tags</label>
          <v-select multiple taggable push-tags></v-select>
        </div>
        <div class="row m-t-sm">
          <label for="file">Files</label>
          <input class="form-control" type="file" id="task-modal-file" ref="taskFile" multiple  @change="handleFileChange"/>
        </div>
        <div class="row m-t-xs">
          <label>Data</label>
          <data-interface :target="newTask.data" :returnType="'object'"></data-interface>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-primary pull-right" @click="addTask()"><i class="fa fa-plus m-r-xs"></i>Add Task</button>
        <button v-if="pbn" class="btn btn-success pull-right m-r-xs" @click="addTask(true)"><i class="fa fa-share m-r-xs"></i>Add task and go to task view</button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import KeyValueInterface from '../../../Helpers/Modal/KeyValueInterface.vue'
import { useProjectStore } from '../../../../stores/ProjectStore'
import { storeToRefs } from 'pinia'
import { useTaskStore } from '../../../../stores/TaskStore'
import { useDataStore } from '../../../../stores/DataStore'

export default {
  props: {
    pbn: { default: null },
    project: { default: null }
  },
  setup () {
    const projectStore = useProjectStore()
    const { projects } = storeToRefs(projectStore)
    if (!projects.length) projectStore.loadProjects()

    const taskStore = useTaskStore()
    const statuses = taskStore.taskStatuses
    const priorities = taskStore.taskPriorities

    const data = useDataStore()
    data.loadDepartments()
    const { departments } = storeToRefs(data)
    if (!departments.length) data.loadDepartments()

    return { taskStore, projects, statuses, priorities, departments }
  },
  data () {
    return {
      newTask: {
        title: '',
        priority: 'normal',
        status: 'created',
        data: {},
        requestedByClient: false,
        linkedResources: null
      },
      selectedProject: {},
      selectedFiles: null,
      pbnOptions: [],
      projectOptions: [],
      loadingPbns: false
    }
  },
  components: {
    dataInterface: KeyValueInterface
  },
  computed: {
    ...mapGetters({
      users: 'getUsers',
      f: 'getFilters'
    })
  },
  mounted () {
    if (!this.f.clients) this.$store.dispatch('loadFilters')
    if (!this.users.length) this.$store.dispatch('loadUsers')
    this.assignProject()
    this.getGroupProjects()
    this.assignLinkedResources()
  },
  methods: {
    initNewTask () {
      this.newTask = {
        title: '',
        priority: 'normal',
        status: 'created',
        data: {},
        requestedByClient: false,
        linkedResources: null
      }
    },
    handleFileChange () {
      this.selectedFiles = this.$refs.taskFile.files
    },
    async createFormData () {
      const formData = new FormData()
      Object.keys(this.newTask).forEach(k => {
        if (k !== 'selectedFiles') {
          const val = typeof this.newTask[k] === 'object' ? JSON.stringify(this.newTask[k]) : this.newTask[k]
          formData.append(k, val)
        }
      })
      for (let i = 0; i < this.$refs.taskFile.files.length; i++) {
        let file = this.$refs.taskFile.files[i]
        formData.append(`files[${i}]`, file)
      }
      return formData
    },
    async addTask (redirect = false) {
      try {
        if (!this.newTask.title.trim().length) {
          this.$toastr.warning('Title field is mandatory')
          return
        }
        if (this.newTask.requestedByClient && !this.newTask.project) {
          this.$toastr.warning('Project field cannot be empty if task is requested by a client')
          return
        }

        Object.keys(this.newTask).forEach(k => [undefined, null, ''].includes(this.newTask[k]) && delete this.newTask[k])

        let task = null
        if (this.selectedFiles) {
          const formData = await this.createFormData()
          task = (await axios.post('/v2/tasks', formData)).data
        } else {
          task = (await axios.post('/v2/tasks', this.newTask)).data
        }

        if (redirect) {
          this.$router.push(`/task-manager/tasks/${task.id}`)
        }

        this.taskStore.loadTasks()
        this.$toastr.success('Task added', 'Success')
        $('#add-task').modal('hide')
        this.initNewTask()
        this.assignProject()
      } catch (error) {
        this.$toastr.error(error, 'Failed to add task')
      }
    },
    updatePriority () {
      this.newTask.priority = this.newTask.requestedByClient ? 'critical' : this.newTask.priority
    },
    async getPbnFromGroup (groupId = null) {
      if (this.pbn) return

      if (groupId) {
        this.loadPbns(groupId)
        return
      }

      if (!this.newTask.project) {
        this.pbnOptions = []
        this.newTask.linkedResources = null
        return
      }

      this.selectedProject = (await axios.get(`/v2/projects/${this.newTask.project}`)).data
      if (this.selectedProject.group) {
        this.loadPbns(this.selectedProject.group.id)
      } else {
        this.pbnOptions = []
        this.newTask.linkedResources = null
      }
    },
    loadPbns (id) {
      this.loadingPbns = true
      axios.get(`/pbn/list?groups=${id}`)
        .then(r => {
          this.pbnOptions = r.data.data
          this.loadingPbns = false
        })
    },
    async assignProject () {
      if (this.project) this.newTask.project = this.project.id
      if (this.project && this.project.group) this.getPbnFromGroup(this.project.group.id)
    },
    async getGroupProjects () {
      if (!this.pbn || !this.pbn.group) return
      this.projectOptions = (await axios.get(`/v2/projects?group=${this.pbn.group.id}`)).data
    },
    assignLinkedResources () {
      if (!this.pbn) return
      this.newTask.linkedResources = this.pbn.id
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Tasks/AddTaskModal.vue